import { FormikEmail } from "../../../../../components/FormikFields/FormikEmail.js";
import { FormikPhone } from "../../../../../components/FormikFields/FormikPhone.js";
import { FormikText } from "../../../../../components/FormikFields/FormikText.js";
import "react";
import { FormLayout } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { Formik } from "formik";
import * as Yup from "yup";
//#region src/modules/Organizations/shared/Subcription/components/FormikBillingContactForm.tsx
var initialValues = {
	email: "",
	name: "",
	phone: ""
};
var ValidationSchema = Yup.object().shape({
	email: Yup.string().nullable(),
	name: Yup.string().required("Name is required"),
	phone: Yup.string().nullable()
});
function FormikBillingContactForm({ contactValues, isSubmitting, onSubmit }) {
	return /* @__PURE__ */ jsx(Formik, {
		initialValues: contactValues ? contactValues : initialValues,
		onSubmit,
		validationSchema: ValidationSchema,
		children: ({ submitForm }) => /* @__PURE__ */ jsxs(FormLayout, {
			space: "sm",
			children: [
				/* @__PURE__ */ jsx(FormikText, {
					name: "name",
					label: "Name",
					hint: "Required"
				}),
				/* @__PURE__ */ jsx(FormikEmail, {
					name: "email",
					label: "Email"
				}),
				/* @__PURE__ */ jsx(FormikPhone, {
					name: "phone",
					label: "Phone"
				}),
				/* @__PURE__ */ jsx(FormLayout.Controls, {
					onSubmit: submitForm,
					submitting: isSubmitting,
					submitLabel: "Save"
				})
			]
		})
	});
}
//#endregion
export { FormikBillingContactForm };

//# sourceMappingURL=FormikBillingContactForm.js.map